import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, AppFloatingConfigurator, ButtonModule],
    template: `
        <div class="hidden"><app-floating-configurator /> </div>
        <div class="flex items-center justify-center min-h-screen overflow-hidden login-bg">
            <div class="flex flex-col items-center justify-center">
                <div class="flex justify-center items-center mb-8">
                    <img src="/images/truthstart_logo.webp" alt="" srcset="" class="cursor-pointer" [routerLink]="['/']">
                </div>
                <div>
                    <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center rounded-xl">
                        <span class="text-primary font-bold text-3xl">404</span>
                        <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl lg:text-5xl mb-2">Not Found</h1>
                        <div class="text-surface-600 dark:text-surface-200 mb-8">Requested resource is not available.</div>
                        
                        <p-button label="Go to Home" routerLink="/" />
                    </div>
                </div>
            </div>
        </div>`
})
export class Notfound { }
